import {
  Button,
  Divider,
  Input,
  InputNumber,
  message,
  Modal,
  Radio,
  Select,
  Switch,
  Tabs,
  Tag,
  Tooltip,
  Typography,
  Upload,
  Checkbox,
  Dropdown,
  Menu,
  Collapse,
} from 'antd';
import { useParams } from 'react-router-dom';
import { Controller, FormProvider, useFieldArray, useForm, useFormContext } from 'react-hook-form';
import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import ReactQuill, { Quill } from 'react-quill';
import { isEqual, keys, snakeCase } from 'lodash-es';
import 'quill-mention';
import { Parser } from 'expr-eval';
import DragIndicatorIcon from '../../../assets/icons/drag-indicator.svg';
// import { ReactComponent as PaypalIcon } from '../../../assets/icons/paypal.svg';
import PaypalIcon from '../../../assets/images/paypal-full.png';
import StripeIcon from '../../../assets/images/stripe-full.png';
import RazorpayIcon from '../../../assets/images/razorpay-full.png';
import CashIcon from '../../../assets/images/cash.png';

import ImgCrop from 'antd-img-crop';
import { ObjectId } from '../../../utils/uuid';
import { isValidUrl, scrollEnd, uploadImageToS3 } from '../../../utils/helpers';
import Icon, {
  DeleteOutlined,
  FileImageOutlined,
  InboxOutlined,
  LoadingOutlined,
  PlusOutlined,
  QuestionCircleOutlined,
  NumberOutlined,
  CloseOutlined,
  MoreOutlined,
  UploadOutlined,
  SettingOutlined,
  EditOutlined,
  CloseCircleOutlined,
} from '@ant-design/icons';
import UploadsPreview from '../../UploadsPreview';
import { useDispatch, useSelector } from 'react-redux';
import { removeDuplicateError, setDuplicateError } from '../../../store/actions/errorActions';
import Dragger from 'antd/lib/upload/Dragger';
import { useTranslation } from 'react-i18next';
import 'react-quill/dist/quill.snow.css';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { formByIdSelector, formQuestionsSelector } from '../../../store/selectors/formSelector';
import { alphabetOnlyId, tinyId } from '../../../utils/tinyid';
import FormulaEditor from './FormulaEditor';
import PaymentMethodEditor from './PaymentMethodEditor';
import { renderToString } from 'react-dom/server';
import {
  currenciesData,
  currencyList,
  formatCurrency,
  parseCurrency,
  paypalSupportedCurrencies,
} from '../../../utils/currencies';

// const Delta = Quill.import('delta');
// const Keyboard = Quill.import('modules/keyboard');

// // disable tab key
// Keyboard.DEFAULTS.bindings['tab'] = {
//   key: 'Tab',
//   handler: function () {
//     // Do nothing
//   },
// };

// // disable enter key
// Keyboard.DEFAULTS.bindings['enter'] = {
//   key: 'Enter',
//   handler: function () {
//     // Do nothing
//   },
// };

const { Option } = Select;
const HIDE_TEXT = ['ADDRESS'];
const HIDE_DESCRIPTION = ['PAYMENT', 'FORMULA', 'ADDRESS'];
const HIDE_PLACEHOLDER = [
  'HEADER',
  'CHECKBOX',
  'RADIO',
  'RATING',
  'DATE',
  'IMAGE',
  'VIDEO',
  'FILE',
  'PHONE',
  'PAYMENT',
  'FORMULA',
  'ADDRESS',
];
const HIDE_REQUIRED = ['HEADER', 'IMAGE', 'VIDEO', 'FORMULA', 'PAYMENT', 'ADDRESS'];
const SHOW_OPTIONS = ['RADIO', 'CHECKBOX', 'DROPDOWN'];
const SHOW_DROPDOWN = ['DROPDOWN'];
const SHOW_FORMULA_EDITOR = ['FORMULA'];
const HIDE_HELPER = [
  'HEADER',
  'CHECKBOX',
  'RADIO',
  'RATING',
  'TEXT',
  'NUMBER',
  'DROPDOWN',
  'DATE',
  'IMAGE',
  'VIDEO',
  'EMAIL',
  'PHONE',
  'FILE',
];
const HIDE_UPLOADS = [
  'HEADER',
  'IMAGE',
  'VIDEO',
  'EMAIL',
  'PHONE',
  'FILE',
  'PAYMENT',
  'FORMULA',
  'ADDRESS',
];

const TEXT_LABEL = {
  IMAGE: {
    key: 'imageLabel',
    default: 'Image title',
  },
  VIDEO: {
    key: 'videoLabel',
    default: 'Video title',
  },
};

const DESC_LABEL = {
  IMAGE: {
    key: 'imageCaption',
    default: 'Image caption',
  },
  VIDEO: {
    key: 'videoCaption',
    default: 'Video caption',
  },
};

const MERCHANTS = [
  {
    name: 'Paypal',
    type: 'paypal',
    icon: PaypalIcon,
  },
  {
    name: 'Stripe',
    type: 'stripe',
    icon: StripeIcon,
  },
  {
    name: 'Razorpay',
    type: 'razorpay',
    icon: RazorpayIcon,
  },
  {
    name: 'Cash',
    type: 'cash',
    icon: CashIcon,
  },
];

export const MERCHANTS_ICONS = {
  paypal: PaypalIcon,
  stripe: StripeIcon,
  razorpay: RazorpayIcon,
  cash: CashIcon,
};

const reduceImage = async function (file) {
  const reader = new FileReader();
  const image = new Image();
  const canvas = document.createElement('canvas');
  const dataURItoBlob = (dataURI) => {
    const bytes =
      dataURI.split(',')[0].indexOf('base64') >= 0
        ? window.atob(dataURI.split(',')[1])
        : decodeURIComponent(dataURI.split(',')[1]);
    const mime = dataURI.split(',')[0].split(':')[1].split(';')[0];
    const max = bytes.length;
    const ia = new Uint8Array(max);
    for (var i = 0; i < max; i++) ia[i] = bytes.charCodeAt(i);
    return new Blob([ia], { type: mime });
  };
  const resize = function () {
    canvas.width = image.width;
    canvas.height = image.height;
    canvas.getContext('2d').drawImage(image, 0, 0, image.width, image.height);
    var dataUrl = canvas.toDataURL(file.type, 0.6);
    const blob = dataURItoBlob(dataUrl);
    return new File([blob], file.name, { type: blob.type, lastModified: Date.now() });
  };
  return new Promise(function (resolve) {
    reader.readAsDataURL(file);
    reader.onload = function (readerEvent) {
      image.src = readerEvent.target.result;
      image.onload = function () {
        return resolve(resize());
      };
    };
  });
};

const FieldProperties = ({ questions, question, questionId, update }) => {
  const containerRef = useRef(null);

  const [uploading, setUploading] = useState(false);
  const [optionImageUploading, setOptionImageUploading] = useState({ state: false, id: null });

  const methods = useForm({
    mode: 'onChange',
  });

  const { control, getValues, setValue, watch } = methods;

  const [watchCurrency, watchPaymentAmountType, watchAssignValues, watchNumberType] = watch([
    'currency',
    'paymentAmountType',
    'assignValues',
    'numberType',
  ]);

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { fields, append, remove, swap } = useFieldArray({
    control,
    name: 'options',
  });

  const merchantsFieldArrayProps = useFieldArray({
    control,
    name: 'merchants',
  });

  const addressFieldArrayProps = useFieldArray({
    control,
    name: 'fields',
    keyName: 'keyId',
  });

  // const params = useParams();
  // const form = useSelector(formByIdSelector(params.id));
  // const formQuestions = formQuestionsSelector(form);

  const availableFieldsToLinkInPayments = useMemo(
    () =>
      questions?.reduce((acc, question) => {
        if (['CHECKBOX', 'RADIO', 'FORMULA', 'NUMBER', 'DROPDOWN'].includes(question?.type)) {
          acc.push({
            id: question?.questionId,
            value: question?.label,
            type: question?.type,
          });
        }
        return acc;
      }, []),
    [questions],
  );

  useEffect(() => {
    if (question) keys(question).map((key) => setValue(key, question[key]));
    if (question.type === 'IMAGE') setValue('image', question.media?.url);
    if (question.type === 'VIDEO') setValue('video', question.media?.url);
  }, [question, setValue]);

  const changeHandler = (key, value) => {
    update({ [key]: value });
  };

  // Update options + Detect duplicates
  const optionChangeHandler = (value, additionalData = {}) => {
    const currentOptions = getValues('options');

    update({ options: currentOptions, ...additionalData });

    const optionsArray = currentOptions.map((option) => option.label).filter((option) => option);
    const optionsSet = new Set(optionsArray);
    if (optionsArray.length !== optionsSet.size) {
      setDuplicateError(dispatch, questionId);
    } else {
      removeDuplicateError(dispatch, questionId);
    }
  };

  const mediaChangeHandler = (key, url, type) => {
    if (!url) return update({ [key]: { type, url: '', name: '' } });
    if (isValidUrl(url)) update({ [key]: { type, url, name: '' } });
  };

  const addOption = () => {
    const currentOptions = getValues('options');
    const label = `option ${currentOptions.length + 1}`;
    append({
      _id: ObjectId(),
      label,
      value: '',
      media: '',
    });

    optionChangeHandler(label);
    scrollEnd(containerRef.current);
  };

  // const addDropdownTags = (options) => {
  //   append(options);
  //   optionChangeHandler();
  //   scrollEnd(containerRef.current);
  // };

  const handleBulkOptionsAdd = (options, assignValues) => {
    setValue('options', options);
    setValue('assignValues', assignValues);
    optionChangeHandler('', { assignValues });
    setIsBulkAddModalOpen(false);
  };

  const beforeUploadHandler = (id, file) => {
    console.log('🚀 ~ beforeUploadHandler ~ file:', file);
    if (!['image/png', 'image/jpg', 'image/jpeg', 'image/svg+xml'].includes(file.type)) {
      message.error(`${file.type} is not supported`);
      return Upload.LIST_IGNORE;
    }
    return true;
  };

  const uploadQuestionImage = async (id, options) => {
    let compressedImage;
    try {
      compressedImage = await reduceImage(options.file);
      compressedImage.uid = options.file.uid;
      options.file = compressedImage;
    } catch (e) {
      console.log(e);
      // Continue with the un-compressed image if exception is encountered
    }

    const fileName = `${id}-${Date.now()}.${options.file.name.replace(/^.*\./, '').toLowerCase()}`;
    const uploadResponse = await uploadImageToS3(fileName, setUploading, options);

    const { type, url, name } = uploadResponse;

    update({ ...getValues(), media: { type, url, name } });
  };

  const uploadOptionImage = async (id, options) => {
    console.log('🚀 ~ uploadOptionImage ~ id:', id);
    const fileName = `${id}-${Date.now()}.${options.file.name.replace(/^.*\./, '').toLowerCase()}`;
    function handleOptionImageUploadLoading(state) {
      setOptionImageUploading({
        id,
        state,
      });
    }
    const uploadResponse = await uploadImageToS3(fileName, handleOptionImageUploadLoading, options);
    const values = getValues('options');
    const newOptions = values.map((el) => (el._id === id ? { ...el, media: uploadResponse } : el));
    update({ options: newOptions });
  };

  const removeQuestionImage = () => {
    update({ media: {} });
  };

  // Workaround for changing react quill default placeholder
  useEffect(() => {
    const input = document.querySelector('.ql-tooltip input[data-link]');
    if (input) {
      input.dataset.link = 'https://www.site.com';
      input.placeholder = 'https://www.site.com';
    }
    const container = document.querySelector('.ql-container');
    if (container) {
      container.oncontextmenu = function (event) {
        if (event.pointerType === 'touch' && window.getSelection().toString()) {
          event.preventDefault();
        }
      };
    }
  }, []);

  const removeOptionImage = (id) => {
    if (!id) return;
    const values = getValues('options');
    const newOptions = values.map((el) => {
      if (el._id !== id) return el;
      const { media, ...rest } = el;
      return { ...rest };
    });
    update({ options: newOptions });
  };

  const onImageTabChange = (key) => {
    // clear image field if image has already been uploaded using uploader
    if (key === 'link' && question.media?.type !== 'url') setValue('image', '');
  };

  const allowedFileTypes = [
    { label: t('builder:propertiesPanel.file.allType'), value: 'all' },
    { label: 'PDF', value: 'pdf' },
    { label: t('builder:propertiesPanel.file.imageType'), value: 'image' },
    { label: t('builder:propertiesPanel.file.videoType'), value: 'video' },
  ];

  function handleOptionsDragEnd(result) {
    const { source, destination } = result;
    if (destination == null) return;
    swap(source.index, destination.index);
    const reorderedOptions = getValues('options');
    update({ options: reorderedOptions });
  }

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isBulkAddModalOpen, setIsBulkAddModalOpen] = useState(false);

  const showAddPaymentMethodModal = () => {
    setIsModalOpen(true);
  };

  const handleAddPaymentMethod = (merchant) => {
    if (!merchant) return;
    merchantsFieldArrayProps.append(merchant);
    update({ merchants: getValues('merchants') });
    setIsModalOpen(false);
  };

  const toggleOptionWeights = () => {
    update({ assignValues: !getValues('assignValues') });
  };

  return (
    <div className="properties-container" ref={containerRef}>
      <FormProvider {...methods}>
        {question?.type === 'SECTION' ? (
          <>
            <div className="form-group">
              <label className="form-group-label">
                {t('builder:propertiesPanel.section.label')}
                <Tooltip placement="top" title={t('builder:propertiesPanel.section.labelTooltip')}>
                  <QuestionCircleOutlined />
                </Tooltip>
              </label>
              <Controller
                render={({ field }) => (
                  <Input
                    size="large"
                    {...field}
                    onChange={(e) => {
                      field.onChange(e);
                      changeHandler(field.name, e.target.value);
                    }}
                  />
                )}
                name="label"
                control={control}
              />
            </div>

            <div className="form-group">
              <label className="form-group-label">
                {t('builder:propertiesPanel.section.nextButtonLabel')}
                {/* <Tooltip placement="top" title={t('builder:propertiesPanel.section.labelTooltip')}>
                <QuestionCircleOutlined />
              </Tooltip> */}
              </label>
              <Controller
                render={({ field }) => (
                  <Input
                    size="large"
                    {...field}
                    onChange={(e) => {
                      field.onChange(e);
                      changeHandler(field.name, e.target.value);
                    }}
                  />
                )}
                name="nextButtonText"
                control={control}
              />
            </div>
            <div className="form-group">
              <label className="form-group-label">
                {t('builder:propertiesPanel.section.prevButtonLabel')}
              </label>
              <Controller
                render={({ field }) => (
                  <Input
                    size="large"
                    {...field}
                    onChange={(e) => {
                      field.onChange(e);
                      changeHandler(field.name, e.target.value);
                    }}
                  />
                )}
                name="prevButtonText"
                control={control}
              />
            </div>
            {/* <div className="form-group row">
              <label className="form-group-label">
                {t('builder:propertiesPanel.section.allowBack')}
              </label>
              <Controller
                render={({ field: { value, ...rest } }) => (
                  <Switch
                    checked={value}
                    {...rest}
                    onChange={(value) => {
                      rest.onChange(value);
                      changeHandler(rest.name, value);
                    }}
                  />
                )}
                name="allowBack"
                control={control}
              /> */}
          </>
        ) : (
          <>
            {question?.type === 'IMAGE' && (
              <div className="form-group">
                <label className="form-group-label">
                  {t('builder:propertiesPanel.image.label', 'Image URL')}
                  <Tooltip
                    placement="top"
                    title={t('builder:propertiesPanel.image.labelTooltip', 'Enter the embed url')}
                  >
                    <QuestionCircleOutlined />
                  </Tooltip>
                </label>
                <Tabs
                  defaultActiveKey={question.media?.type === 'url' ? 'link' : 'upload'}
                  onChange={onImageTabChange}
                  style={{ marginTop: -8 }}
                >
                  <Tabs.TabPane tab={t('builder:propertiesPanel.image.upload')} key="upload">
                    <div>
                      {/* hide if image was added using upload and not url */}
                      {question.media?.type === 'url' || !question.media?.url ? (
                        <>
                          <Dragger
                            disabled={uploading}
                            maxCount={1}
                            showUploadList={false}
                            beforeUpload={(file) => beforeUploadHandler(question.questionId, file)}
                            customRequest={(options) =>
                              uploadQuestionImage(question.questionId, options)
                            }
                          >
                            <p className="ant-upload-drag-icon">
                              {uploading ? <LoadingOutlined /> : <InboxOutlined />}
                            </p>
                            <p className="ant-upload-text">
                              {t(
                                'builder:propertiesPanel.image.uploadText',
                                'Click or drag file to this area to upload',
                              )}
                            </p>
                          </Dragger>
                        </>
                      ) : (
                        <>
                          {question.media && question.media.type !== 'url' && (
                            <UploadsPreview
                              url={question.media?.url}
                              remove={removeQuestionImage}
                            />
                          )}
                        </>
                      )}
                    </div>
                  </Tabs.TabPane>
                  <Tabs.TabPane tab={t('builder:propertiesPanel.image.link')} key="link">
                    <Controller
                      render={({ field }) => (
                        <Input
                          size="large"
                          {...field}
                          placeholder={t('builder:propertiesPanel.image.placeholder', 'Image URL')}
                          onChange={(e) => {
                            field.onChange(e);
                            mediaChangeHandler('media', e.target.value, 'url');
                          }}
                        />
                      )}
                      name="image"
                      control={control}
                    />
                  </Tabs.TabPane>
                </Tabs>
              </div>
            )}
            {question?.type === 'VIDEO' && (
              <div className="form-group">
                <label className="form-group-label">
                  {t('builder:propertiesPanel.video.label', 'Video URL')}

                  <Tooltip
                    placement="top"
                    title={t('builder:propertiesPanel.video.labelTooltip', 'Enter the embed URL')}
                  >
                    <QuestionCircleOutlined />
                  </Tooltip>
                </label>
                <Controller
                  render={({ field }) => (
                    <Input
                      size="large"
                      placeholder={`https://www.youtube.com/watch?v=0mhTO2wGhOU`}
                      {...field}
                      onChange={(e) => {
                        field.onChange(e);
                        mediaChangeHandler('media', e.target.value, 'video');
                      }}
                    />
                  )}
                  name="video"
                  control={control}
                />
              </div>
            )}
            {!HIDE_TEXT.includes(question?.type) && (
              <div className="form-group">
                <label className="form-group-label">
                  {TEXT_LABEL[question?.type]
                    ? t(
                        `propertiesPanel.text.${TEXT_LABEL[question?.type].key}`,
                        TEXT_LABEL[question?.type].default,
                      )
                    : t('builder:propertiesPanel.text.label', 'Title')}
                  <Tooltip
                    placement="top"
                    title={t('builder:propertiesPanel.text.labelTooltip', 'Type your question')}
                  >
                    <QuestionCircleOutlined />
                  </Tooltip>
                </label>
                <Controller
                  render={({ field }) => (
                    <Input
                      size="large"
                      {...field}
                      onChange={(e) => {
                        field.onChange(e);
                        changeHandler(field.name, e.target.value);
                      }}
                    />
                  )}
                  name="label"
                  control={control}
                />
              </div>
            )}
            {!HIDE_DESCRIPTION.includes(question?.type) && (
              <div className="form-group">
                <label className="form-group-label">
                  {DESC_LABEL[question?.type]
                    ? t(
                        `propertiesPanel.description.${DESC_LABEL[question?.type].key}`,
                        DESC_LABEL[question?.type].default,
                      )
                    : t('builder:propertiesPanel.description.label', 'Subtitle')}
                  <Tooltip
                    placement="top"
                    title={t(
                      'builder:propertiesPanel.description.labelTooltip',
                      'Add additional instructions for the question',
                    )}
                  >
                    <QuestionCircleOutlined />
                  </Tooltip>
                </label>
                <Controller
                  render={({ field }) => (
                    <ReactQuill
                      bounds=".properties-container"
                      modules={{
                        toolbar: {
                          container: ['bold', 'italic', 'link'],
                        },
                      }}
                      formats={['bold', 'italic', 'link']}
                      {...field}
                      placeholder={t(
                        'builder:propertiesPanel.description.placeholder',
                        'Add description text here',
                      )}
                      onChange={(value) => {
                        let desc = '';
                        if (value !== '<p><br></p>') {
                          desc = value;
                        }
                        field.onChange(desc);
                        changeHandler(field.name, desc);
                      }}
                    />
                  )}
                  name="description"
                  control={control}
                />
              </div>
            )}
            {!HIDE_PLACEHOLDER.includes(question?.type) && (
              <div className="form-group">
                <label className="form-group-label">
                  {t('builder:propertiesPanel.placeholderText.label', 'Placeholder')}

                  {/* <Tooltip placement="top" title={''}>
            <QuestionCircleOutlined />
          </Tooltip> */}
                </label>
                <Controller
                  render={({ field }) => (
                    <Input
                      size="large"
                      {...field}
                      onChange={(e) => {
                        field.onChange(e);
                        changeHandler(field.name, e.target.value);
                      }}
                    />
                  )}
                  name="placeholderText"
                  control={control}
                />
              </div>
            )}
            {/* {!HIDE_HELPER.includes(question?.type) && (
              <div className="form-group">
                <label className="form-group-label">
                  Help text
                  <Tooltip placement="top" title={'Add a tooltip to the question'}>
                    <QuestionCircleOutlined />
                  </Tooltip>
                </label>
                <Controller
                  render={({ field }) => (
                    <Input
                      size="large"
                      {...field}
                      onChange={(e) => {
                        field.onChange(e);
                        changeHandler(field.name, e.target.value);
                      }}
                    />
                  )}
                  name="hint"
                  control={control}
                />
              </div>
            )} */}
            {question?.type === 'PAYMENT' && (
              <>
                <div className="form-group">
                  <label className="form-group-label">
                    {t('builder:propertiesPanel.payment.currency')}
                  </label>
                  <Controller
                    render={({ field }) => (
                      <Select
                        showSearch
                        size="large"
                        {...field}
                        onChange={(value, option) => {
                          field.onChange(value);

                          // remove payment methods that are not supported by the selected currency
                          const supportedMethods = question.merchants.filter((merchant) => {
                            if (merchant.type === 'paypal')
                              return paypalSupportedCurrencies.find(({ code }) => code === value);
                            if (merchant.type === 'razorpay') return value === 'INR';
                            return true;
                          });
                          update({ [field.name]: value, merchants: supportedMethods });
                        }}
                      >
                        {currencyList.map((l) => (
                          <Select.Option key={l.code} value={l.code}>
                            {l.code}
                          </Select.Option>
                        ))}
                      </Select>
                    )}
                    control={control}
                    name="currency"
                    defaultValue={'USD'}
                  />
                </div>
                <div className="form-group">
                  <label className="form-group-label">
                    {t('builder:propertiesPanel.payment.paymentAmount')}
                  </label>
                  <Controller
                    render={({ field }) => (
                      <Radio.Group
                        {...field}
                        onChange={(e) => {
                          field.onChange(e);
                          changeHandler(field.name, e.target.value);
                        }}
                      >
                        <Radio value="fixed">
                          {t('builder:propertiesPanel.payment.fixedValue')}
                        </Radio>
                        <Radio value="linkedField">
                          {t('builder:propertiesPanel.payment.QuestionValue')}
                        </Radio>
                      </Radio.Group>
                    )}
                    control={control}
                    name="paymentAmountType"
                    defaultValue={'fixed'}
                  />
                  {watchPaymentAmountType === 'fixed' && (
                    <Controller
                      render={({ field }) => (
                        <InputNumber
                          size="large"
                          min={0}
                          formatter={(value) =>
                            formatCurrency(value, watchCurrency, { noTrailingZeros: true })
                          }
                          parser={(value) => parseCurrency(value, watchCurrency)}
                          style={{ width: '100%' }}
                          addonBefore={currenciesData[watchCurrency]?.symbol || '$'}
                          stringMode
                          controls={false}
                          {...field}
                          onChange={(value) => {
                            field.onChange(value);
                            changeHandler(field.name, value);
                          }}
                        />
                      )}
                      control={control}
                      name="amount"
                    />
                  )}
                  {watchPaymentAmountType === 'linkedField' && (
                    <Controller
                      render={({ field }) => (
                        <Select
                          showSearch
                          size="large"
                          {...field}
                          onChange={(value, option) => {
                            field.onChange(value);
                            changeHandler(field.name, value);
                          }}
                        >
                          {availableFieldsToLinkInPayments.map((l) => (
                            <Select.Option key={l.id} value={l.id}>
                              {l.value}
                            </Select.Option>
                          ))}
                        </Select>
                      )}
                      control={control}
                      name="linkedField"
                    />
                  )}
                </div>
                <>
                  <Divider />
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                    <Typography.Text strong>
                      {t('builder:propertiesPanel.payment.paymentMethods')}
                    </Typography.Text>
                    <PaymentMethodEditor
                      currentQuestion={question}
                      fieldArrayProps={merchantsFieldArrayProps}
                      update={update}
                    />
                    {MERCHANTS.length !== question?.merchants?.length && (
                      <Button
                        type="ghost"
                        icon={<PlusOutlined />}
                        onClick={showAddPaymentMethodModal}
                        style={{ width: 'fit-content', marginBottom: 12 }}
                      >
                        {t('builder:propertiesPanel.payment.addMethod', 'Add payment method')}
                      </Button>
                    )}

                    <AddPaymentMethod
                      isOpen={isModalOpen}
                      handleOk={handleAddPaymentMethod}
                      handleCancel={() => setIsModalOpen(false)}
                    />
                  </div>
                </>
              </>
            )}
            {SHOW_OPTIONS.includes(question?.type) && (
              <>
                <Divider />
                <div className="form-group">
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <label className="form-group-label">
                      {t('builder:propertiesPanel.options.label', 'Options')}
                    </label>
                    {question.type === 'DROPDOWN' && (
                      <Button
                        onClick={() => setIsBulkAddModalOpen(true)}
                        type="dashed"
                        size="small"
                      >
                        {t('builder:propertiesPanel.options.bulkAdd', 'Bulk edit')}
                      </Button>
                    )}
                  </div>
                  <DragDropContext onDragEnd={handleOptionsDragEnd}>
                    <Droppable droppableId="form-question-options-section">
                      {(provided) => (
                        <div {...provided.droppableProps} ref={provided.innerRef}>
                          {fields.map((item, index) => {
                            return (
                              <Draggable key={item._id} draggableId={item._id} index={index}>
                                {(provided) => (
                                  <div
                                    className="options-container"
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    style={{ ...provided.draggableProps.style }}
                                  >
                                    <div className="drag-handle">
                                      <img
                                        src={DragIndicatorIcon}
                                        alt="drag icon"
                                        style={{ marginBottom: '2px', marginRight: '2px' }}
                                      />
                                    </div>

                                    <div className="options-input-group">
                                      <Controller
                                        render={({ field }) => (
                                          <Input
                                            size="large"
                                            {...field}
                                            placeholder={`${t(
                                              'builder:propertiesPanel.options.placeholder',
                                              'option',
                                            )} ${index + 1}`}
                                            onChange={(e) => {
                                              field.onChange(e);
                                              optionChangeHandler(e.target.value);
                                            }}
                                          />
                                        )}
                                        name={`options.${index}.label`}
                                        control={control}
                                        defaultValue={item.label} // make sure to set up defaultValue
                                      />

                                      <div
                                        className="options-action"
                                        style={{ right: question.type === 'DROPDOWN' ? 0 : 50 }}
                                      ></div>
                                    </div>
                                    {watchAssignValues && (
                                      <Controller
                                        render={({ field }) => (
                                          <InputNumber
                                            size="large"
                                            min={0}
                                            {...field}
                                            placeholder={0}
                                            controls={false}
                                            onChange={(value) => {
                                              field.onChange(value);
                                              optionChangeHandler(value);
                                            }}
                                            style={{ flex: 1, flexBasis: 60 }}
                                          />
                                        )}
                                        name={`options.${index}.weight`}
                                        control={control}
                                        defaultValue={item.weight} // make sure to set up defaultValue
                                      />
                                    )}

                                    <Dropdown
                                      placement="bottomRight"
                                      overlay={
                                        <Menu>
                                          {['RADIO', 'CHECKBOX'].includes(question?.type) && (
                                            <Menu.Item
                                              icon={
                                                optionImageUploading.state &&
                                                optionImageUploading.id === item._id ? (
                                                  <UploadOutlined />
                                                ) : (
                                                  <UploadOutlined />
                                                )
                                              }
                                            >
                                              <ImgCrop quality={0.7}>
                                                <Upload
                                                  maxCount={1}
                                                  beforeUpload={(file) =>
                                                    beforeUploadHandler(item._id, file)
                                                  }
                                                  accept="image/*"
                                                  customRequest={(options) =>
                                                    uploadOptionImage(item._id, options)
                                                  }
                                                  onRemove={() => removeOptionImage(item._id)}
                                                  showUploadList={false}
                                                  disabled={
                                                    optionImageUploading.state &&
                                                    optionImageUploading.id !== item._id
                                                  }
                                                >
                                                  {item?.media?.url
                                                    ? t(
                                                        'builder:propertiesPanel.options.changeImage',
                                                        'Change image',
                                                      )
                                                    : t(
                                                        'builder:propertiesPanel.options.addImage',
                                                        'Add image',
                                                      )}
                                                </Upload>
                                              </ImgCrop>
                                            </Menu.Item>
                                          )}
                                          {item?.media?.url && (
                                            <Menu.Item
                                              icon={<CloseCircleOutlined />}
                                              onClick={() => {
                                                removeOptionImage(item._id);
                                              }}
                                            >
                                              Remove image
                                            </Menu.Item>
                                          )}
                                          <Menu.Item
                                            icon={
                                              !watchAssignValues ? (
                                                <NumberOutlined />
                                              ) : (
                                                <CloseOutlined />
                                              )
                                            }
                                            onClick={toggleOptionWeights}
                                          >
                                            {!watchAssignValues
                                              ? t(
                                                  'builder:propertiesPanel.options.assignValues',
                                                  'Assign values',
                                                )
                                              : t(
                                                  'builder:propertiesPanel.options.removeValues',
                                                  'Remove values',
                                                )}
                                          </Menu.Item>
                                          <Menu.Item
                                            icon={<DeleteOutlined />}
                                            danger
                                            onClick={() => {
                                              remove(index);
                                              optionChangeHandler();
                                            }}
                                          >
                                            {t('delete.text', 'Delete')}
                                          </Menu.Item>
                                        </Menu>
                                      }
                                      trigger={['click']}
                                    >
                                      <Button
                                        icon={<MoreOutlined />}
                                        size="large"
                                        onClick={(e) => e.preventDefault()}
                                        style={{ minWidth: 37, height: 37 }}
                                      />
                                    </Dropdown>
                                    {/* <Button
                                      icon={<DeleteOutlined />}
                                      title="delete"
                                      className="option-delete-button"
                                      // type="text"
                                      size="large"
                                      onClick={() => {
                                        remove(index);
                                        optionChangeHandler();
                                      }}
                                    ></Button> */}
                                  </div>
                                )}
                              </Draggable>
                            );
                          })}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>

                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      gap: 8,
                      marginTop: 8,
                    }}
                  >
                    <Button onClick={addOption} block>
                      {t('builder:propertiesPanel.options.add', 'Add option')}
                    </Button>
                    <BulkAddOptions
                      key={isBulkAddModalOpen}
                      isOpen={isBulkAddModalOpen}
                      handleOk={handleBulkOptionsAdd}
                      handleCancel={() => setIsBulkAddModalOpen(false)}
                    />
                  </div>
                </div>
                {['RADIO', 'CHECKBOX'].includes(question?.type) && (
                  <div className="form-group row" style={{ marginTop: 24 }}>
                    <>
                      <label className="form-group-label">
                        {t('builder:propertiesPanel.options.otherLabel', `Add 'Other' option`)}
                      </label>
                      <Controller
                        render={({ field: { value, ...rest } }) => (
                          <Switch
                            checked={value}
                            {...rest}
                            onChange={(value) => {
                              rest.onChange(value);
                              changeHandler(rest.name, value);
                            }}
                          />
                        )}
                        name="allowOther"
                        control={control}
                      />
                    </>
                  </div>
                )}
                <Divider />
              </>
            )}
            {/* {SHOW_DROPDOWN.includes(question?.type) && (
              <>
                <Divider />
                <div className="form-group">
                  <label className="form-group-label">
                    {t('builder:propertiesPanel.options.label', 'Options')}
                  </label>
                  <TagEditor
                    tags={fields}
                    control={control}
                    updateTag={optionChangeHandler}
                    addTags={addDropdownTags}
                    removeTag={remove}
                  />
                </div>
                <Divider />
              </>
            )} */}
            {!HIDE_UPLOADS.includes(question?.type) && (
              <>
                {/* <Divider /> */}
                <div className="form-group">
                  <label className="form-group-label">
                    {t('builder:propertiesPanel.uploads.label', 'Image')}
                    <Tooltip
                      placement="top"
                      title={t(
                        'builder:propertiesPanel.uploads.labelTooltip',
                        'Add an image to the question',
                      )}
                    >
                      <QuestionCircleOutlined />
                    </Tooltip>
                  </label>
                  {!question.media?.url ? (
                    <Controller
                      render={({ field: { value, ...rest } }) => (
                        <Upload
                          maxCount={1}
                          beforeUpload={(file) => beforeUploadHandler(question.questionId, file)}
                          customRequest={(options) =>
                            uploadQuestionImage(question.questionId, options)
                          }
                          onChange={(value) => {
                            rest.onChange(value);
                          }}
                          showUploadList={false}
                          onRemove={removeQuestionImage}
                          {...rest}
                        >
                          <Button icon={<FileImageOutlined />} loading={uploading}>
                            {t('builder:propertiesPanel.uploads.buttonText', 'Choose a file')}
                          </Button>
                        </Upload>
                      )}
                      name="media"
                      control={control}
                    />
                  ) : (
                    <UploadsPreview url={question.media.url} remove={removeQuestionImage} />
                  )}
                </div>
              </>
            )}

            {question?.type === 'DATE' && (
              <>
                <Divider />
                <div className="form-group">
                  <label className="form-group-label">
                    {t('builder:propertiesPanel.date.datePickerLabel', 'Date picker type')}

                    <Tooltip
                      placement="top"
                      title={t(
                        'builder:propertiesPanel.date.datePickerLabelTooltip',
                        'Select the type of date picker',
                      )}
                    >
                      <QuestionCircleOutlined />
                    </Tooltip>
                  </label>
                  <Controller
                    render={({ field: { value, ...rest } }) => (
                      <Radio.Group
                        buttonStyle="solid"
                        value={value ? value : 'none'}
                        {...rest}
                        onChange={(e) => {
                          rest.onChange(e);
                          changeHandler(rest.name, e.target.value);
                        }}
                      >
                        <Radio.Button value="date">
                          {' '}
                          {t('builder:propertiesPanel.date.datePickerDate', 'Date')}
                        </Radio.Button>
                        <Radio.Button value="datetime">
                          {t('builder:propertiesPanel.date.datePickerDateTime', 'Date & Time')}
                        </Radio.Button>
                      </Radio.Group>
                    )}
                    name="datePickerMode"
                    control={control}
                  />
                </div>
                {question?.datePickerMode === 'datetime' && (
                  <div className="form-group">
                    <label className="form-group-label">
                      {t('builder:propertiesPanel.date.formatPickerLabel', 'Time format')}
                      <Tooltip
                        placement="top"
                        title={t(
                          'builder:propertiesPanel.date.formatPickerLabelTooltip',
                          'Select which time format to use',
                        )}
                      >
                        <QuestionCircleOutlined />
                      </Tooltip>
                    </label>
                    <Controller
                      render={({ field: { value, ...rest } }) => (
                        <Radio.Group
                          buttonStyle="solid"
                          value={value}
                          {...rest}
                          onChange={(e) => {
                            rest.onChange(e);
                            changeHandler(rest.name, e.target.value);
                          }}
                        >
                          <Radio.Button value={true}>
                            {t('builder:propertiesPanel.date.formatPickerAMPM', 'AM/PM')}
                          </Radio.Button>
                          <Radio.Button value={false}>
                            {t('builder:propertiesPanel.date.formatPicker24Hour', '24 HOUR')}
                          </Radio.Button>
                        </Radio.Group>
                      )}
                      name="use12Hours"
                      control={control}
                    />
                  </div>
                )}

                <div className="form-group row">
                  <label className="form-group-label">
                    {t('builder:propertiesPanel.date.disablePast')}
                  </label>
                  <Controller
                    render={({ field: { value, ...rest } }) => (
                      <Switch
                        checked={value}
                        {...rest}
                        onChange={(value) => {
                          rest.onChange(value);
                          changeHandler(rest.name, value);
                        }}
                      />
                    )}
                    name="disablePastDate"
                    control={control}
                  />
                </div>
                <div className="form-group row">
                  <label className="form-group-label">
                    {t('builder:propertiesPanel.date.disableFuture')}
                  </label>
                  <Controller
                    render={({ field: { value, ...rest } }) => (
                      <Switch
                        checked={value}
                        {...rest}
                        onChange={(value) => {
                          rest.onChange(value);
                          changeHandler(rest.name, value);
                        }}
                      />
                    )}
                    name="disableFutureDate"
                    control={control}
                  />
                </div>
              </>
            )}
            {question?.type === 'RATING' && (
              <>
                <Divider />
                <div className="form-group">
                  <label className="form-group-label">
                    {t('builder:propertiesPanel.rating.stylePickerLabel', 'Rating Style')}
                    <Tooltip
                      placement="top"
                      title={t(
                        'builder:propertiesPanel.rating.stylePickerLabelTooltip',
                        'Select the rating style',
                      )}
                    >
                      <QuestionCircleOutlined />
                    </Tooltip>
                  </label>
                  <Controller
                    render={({ field: { value, ...rest } }) => (
                      <Radio.Group
                        buttonStyle="solid"
                        value={value}
                        {...rest}
                        onChange={(e) => {
                          rest.onChange(e);
                          changeHandler(rest.name, e.target.value);
                        }}
                      >
                        <Radio.Button value="star">
                          {t('builder:propertiesPanel.rating.stylePickerStar', 'Star')}
                        </Radio.Button>
                        <Radio.Button value="survey">
                          {t('builder:propertiesPanel.rating.stylePickerSurvey', 'Survey')}
                        </Radio.Button>
                      </Radio.Group>
                    )}
                    name="ratingStyle"
                    control={control}
                  />
                </div>
              </>
            )}
            {question?.type === 'FILE' && (
              <>
                <Divider />
                <div className="form-group">
                  <label className="form-group-label">
                    {t('builder:propertiesPanel.file.allowedFileType')}
                  </label>
                  <Controller
                    control={control}
                    name="uploadType"
                    defaultValue="all"
                    render={({ field }) => {
                      return (
                        <Select
                          style={{ width: '100%' }}
                          {...field}
                          onChange={(value) => {
                            field.onChange(value);
                            changeHandler(field.name, value);
                          }}
                        >
                          {allowedFileTypes.map((item) => (
                            <Option key={item.value} value={item.value}>
                              {item.label}
                            </Option>
                          ))}
                        </Select>
                      );
                    }}
                  />
                </div>
              </>
            )}
            {question?.type === 'NUMBER' && (
              <>
                <Divider />
                <div className="form-group">
                  <label className="form-group-label">
                    {t('builder:propertiesPanel.number.inputType', 'Input type')}
                  </label>
                  <Input.Group compact style={{ width: '100%' }}>
                    <Controller
                      render={({ field }) => (
                        <Select
                          showSearch
                          size="large"
                          {...field}
                          style={{ width: watchNumberType === 'currency' ? '76%' : '100%' }}
                          onChange={(value, option) => {
                            field.onChange(value);
                            update({
                              [field.name]: value,
                              ...(watchNumberType === 'currency' &&
                                !getValues('numberCurrencyCode') && {
                                  numberCurrencyCode: 'USD',
                                }),
                            });
                          }}
                        >
                          <Select.Option key={'integer'} value={'integer'}>
                            {t('builder:propertiesPanel.number.inputTypeInteger', 'Integer')}
                          </Select.Option>
                          <Select.Option key={'decimal'} value={'decimal'}>
                            {t('builder:propertiesPanel.number.inputTypeDecimal', 'Decimal')}
                          </Select.Option>
                          <Select.Option key={'currency'} value={'currency'}>
                            {t('builder:propertiesPanel.number.inputTypeCurrency', 'Currency')}
                          </Select.Option>
                        </Select>
                      )}
                      control={control}
                      name="numberType"
                      defaultValue={'integer'}
                    />
                    {watchNumberType === 'currency' && (
                      <Controller
                        render={({ field }) => (
                          <Select
                            showSearch
                            size="large"
                            {...field}
                            style={{ minWidth: '24%' }}
                            onChange={(value, option) => {
                              field.onChange(value);
                              update({ [field.name]: value });
                            }}
                          >
                            {currencyList.map((l) => (
                              <Select.Option key={l.code} value={l.code}>
                                {l.code}
                              </Select.Option>
                            ))}
                          </Select>
                        )}
                        control={control}
                        name="numberCurrencyCode"
                        defaultValue={'USD'}
                      />
                    )}
                  </Input.Group>
                </div>
                <div style={{ display: 'flex', gap: 8 }}>
                  <div className="form-group">
                    <label className="form-group-label">
                      {t('builder:propertiesPanel.number.minValue', 'Min Value')}
                    </label>
                    <Controller
                      render={({ field }) => (
                        <InputNumber
                          size="large"
                          min={0}
                          style={{ width: '100%' }}
                          controls={false}
                          {...field}
                          onChange={(value) => {
                            field.onChange(value);
                            changeHandler(field.name, value);
                          }}
                        />
                      )}
                      name="min"
                      control={control}
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-group-label">
                      {t('builder:propertiesPanel.number.maxValue', 'Max Value')}
                    </label>
                    <Controller
                      render={({ field }) => (
                        <InputNumber
                          size="large"
                          style={{ width: '100%' }}
                          controls={false}
                          min={0}
                          {...field}
                          onChange={(value) => {
                            field.onChange(value);
                            changeHandler(field.name, value);
                          }}
                        />
                      )}
                      name="max"
                      control={control}
                    />
                  </div>
                </div>
                {watchNumberType !== 'currency' && (
                  <div style={{ display: 'flex', gap: 8 }}>
                    <div className="form-group">
                      <label className="form-group-label">
                        {t('builder:propertiesPanel.number.prefix', 'Prefix')}
                      </label>
                      <Controller
                        render={({ field }) => (
                          <Input
                            size="large"
                            placeholder="e.g. $, ₹, £"
                            {...field}
                            onChange={(e) => {
                              field.onChange(e);
                              changeHandler(field.name, e.target.value);
                            }}
                          />
                        )}
                        name="prefix"
                        control={control}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-group-label">
                        {t('builder:propertiesPanel.number.suffix', 'Suffix')}
                      </label>
                      <Controller
                        render={({ field }) => (
                          <Input
                            size="large"
                            placeholder="e.g. cm, kg, m"
                            {...field}
                            onChange={(e) => {
                              field.onChange(e);
                              changeHandler(field.name, e.target.value);
                            }}
                          />
                        )}
                        name="suffix"
                        control={control}
                      />
                    </div>
                  </div>
                )}
              </>
            )}
            {question?.type === 'FORMULA' && (
              <>
                <Divider />
                <FormulaEditor
                  control={control}
                  getValues={getValues}
                  onChange={update}
                  questions={questions}
                  currentQuestion={question}
                />
              </>
            )}
            {question?.type === 'ADDRESS' && (
              <AddressFields
                fieldArrayProps={addressFieldArrayProps}
                update={update}
                currentQuestion={question}
              />
            )}

            {!HIDE_REQUIRED.includes(question?.type) && (
              <>
                <Divider />
                <div className="form-group row">
                  <label className="form-group-label">
                    {t('builder:propertiesPanel.required.label', 'Required')}
                  </label>
                  <Controller
                    render={({ field: { value, ...rest } }) => (
                      <Switch
                        checked={value}
                        {...rest}
                        onChange={(value) => {
                          rest.onChange(value);
                          changeHandler(rest.name, value);
                        }}
                      />
                    )}
                    name="required"
                    control={control}
                  />
                </div>
                {question?.type === 'TEXT' && (
                  <div className="form-group row">
                    <label className="form-group-label">
                      {t('builder:propertiesPanel.longAnswer.label', 'Paragraph')}
                    </label>
                    <Controller
                      render={({ field: { value, ...rest } }) => (
                        <Switch
                          checked={value}
                          {...rest}
                          onChange={(value) => {
                            rest.onChange(value);
                            changeHandler(rest.name, value);
                          }}
                        />
                      )}
                      name="longAnswer"
                      control={control}
                    />
                  </div>
                )}
              </>
            )}
            {question?.type === 'FORMULA' && (
              <>
                <Divider />
                <div style={{ display: 'flex', gap: 8 }}>
                  <div className="form-group">
                    <label className="form-group-label">
                      {t('builder:propertiesPanel.number.prefix', 'Prefix')}
                    </label>
                    <Controller
                      render={({ field }) => (
                        <Input
                          size="large"
                          placeholder="e.g. $, ₹, £"
                          {...field}
                          onChange={(e) => {
                            field.onChange(e);
                            changeHandler(field.name, e.target.value);
                          }}
                        />
                      )}
                      name="prefix"
                      control={control}
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-group-label">
                      {t('builder:propertiesPanel.number.suffix', 'Suffix')}
                    </label>
                    <Controller
                      render={({ field }) => (
                        <Input
                          size="large"
                          placeholder="e.g. cm, kg, m"
                          {...field}
                          onChange={(e) => {
                            field.onChange(e);
                            changeHandler(field.name, e.target.value);
                          }}
                        />
                      )}
                      name="suffix"
                      control={control}
                    />
                  </div>
                </div>
                <Divider />
                <div className="form-group row">
                  <label className="form-group-label">
                    {t('builder:propertiesPanel.hidden.label', 'Show in form')}
                  </label>
                  <Controller
                    render={({ field: { value, ...rest } }) => (
                      <Switch
                        checked={!value}
                        {...rest}
                        onChange={(value) => {
                          rest.onChange(!value);
                          changeHandler(rest.name, !value);
                        }}
                      />
                    )}
                    name="hidden"
                    control={control}
                    defaultValue={false}
                  />
                </div>
              </>
            )}
          </>
        )}
      </FormProvider>
    </div>
  );
};

const BulkAddOptions = ({ isOpen, handleOk, handleCancel }) => {
  const { getValues } = useFormContext();
  const [optionsString, setOptionsString] = useState(() => {
    const options = getValues('options');
    const assignValues = getValues('assignValues');
    if (assignValues) {
      return options
        ?.map((option) => `${option.label}:${isFinite(+option.weight) ? option.weight * 1 : 0}`)
        .join('\n');
    }
    return options?.map((option) => option.label).join('\n');
  });
  const [assignValues, setAssignValues] = useState(!!getValues('assignValues'));
  const { t } = useTranslation();

  const toggleAssignValues = (e) => {
    setAssignValues(e.target.checked);
    // if assignValues is true, convert the optionsString to include weights separated by colons and vice versa
    if (e.target.checked) {
      setOptionsString(
        (prev) =>
          prev &&
          prev
            .split(/[\n,]/)
            .map((v) => (v?.match(/^[^:]+:[^:]+$/) ? v : `${v}:0`))
            .join('\n'),
      );
    } else {
      setOptionsString(
        (prev) =>
          prev &&
          prev
            .split(/[\n,]/)
            .map((v) => v.split(':')[0])
            .join('\n'),
      );
    }
  };

  const onOk = () => {
    // split by line breaks and commas and replace all white spaces
    let options = optionsString
      .split(/[\n,]/)
      .map((v) => ({ _id: ObjectId(), label: v?.replace(/\s/g, ''), media: '' }));
    if (assignValues) {
      // split by colons
      options = options.map((option) => {
        const [label, value = ''] = option?.label.split(':');
        return { ...option, label, weight: isFinite(+value) ? value * 1 : 0 };
      });
    }
    handleOk(options, assignValues);
  };

  const onCancel = () => {
    handleCancel();
  };
  return (
    <Modal
      title={t('builder:propertiesPanel.options.bulkAddOptions', 'Bulk Add Options')}
      visible={isOpen}
      onOk={onOk}
      okText={t('translation:common:save', 'Save')}
      onCancel={onCancel}
      centered
      destroyOnClose
    >
      <div style={{ marginBottom: 16 }}>
        <Checkbox onChange={toggleAssignValues} checked={assignValues}>
          {t(
            'builder:propertiesPanel.options.assignNumericValuesToOptions',
            'Assign numeric values to the options',
          )}
        </Checkbox>
      </div>
      <Input.TextArea
        style={{ height: 200 }}
        onChange={(e) => setOptionsString(e.target.value)}
        value={optionsString}
        placeholder={
          assignValues
            ? t(
                'builder:propertiesPanel.options.bulkAddOptionsPlaceholder1',
                `Option1:Value1\nOption2:Value2\nOption3:Value3`,
              )
            : t(
                'builder:propertiesPanel.options.bulkAddOptionsPlaceholder2',
                `Add\nOptions\nlike\nthis\nOr, like, this`,
              )
        }
      />
      <Typography.Paragraph type="secondary" style={{ marginTop: 8, fontSize: '14px' }}>
        {assignValues
          ? t(
              'builder:propertiesPanel.options.bulkAddOptionsDescription1',
              'Separate options using commas or line breaks. Separate labels and values with colons.',
            )
          : t(
              'builder:propertiesPanel.options.bulkAddOptionsDescription2',
              'Separate options using commas or line breaks.',
            )}
      </Typography.Paragraph>
    </Modal>
  );
};

const AddPaymentMethod = ({ isOpen, handleOk, handleCancel }) => {
  const { getValues } = useFormContext();
  const [merchant, setMerchant] = useState(null);
  const { t } = useTranslation(['builder']);

  const merchants = getValues('merchants');

  const isCurrencySupported = (type) => {
    const currency = getValues('currency');
    if (type === 'paypal') return paypalSupportedCurrencies.find(({ code }) => code === currency);
    if (type === 'razorpay') return currency === 'INR';
    return true;
  };

  const onOk = () => {
    handleOk({ type: merchant, ...(merchant === 'cash' && { credentials: { label: 'Cash' } }) });
    setMerchant(null);
  };

  const onCancel = () => {
    setMerchant(null);
    handleCancel();
  };

  return (
    <Modal
      title={t('builder:propertiesPanel.payment.addPaymentMethod')}
      visible={isOpen}
      onOk={onOk}
      okText={t('builder:propertiesPanel.payment.addPaymentMethod')}
      onCancel={onCancel}
      centered
    >
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: 10,
        }}
      >
        {MERCHANTS.filter((el) => !merchants?.find(({ type }) => type === el?.type)).map(
          ({ type, icon }) => (
            <Tooltip
              placement="bottom"
              title={
                !isCurrencySupported(type) && t('builder:propertiesPanel.payment.notSupported')
              }
              key={type}
              popupVisible={false}
            >
              <Button
                disabled={!isCurrencySupported(type)}
                className="merchant-button"
                block
                style={{
                  padding: 32,
                  ...(merchant === type && { backgroundColor: '#fcfffa', borderColor: '#2ab200' }),
                  filter: !isCurrencySupported(type) && 'grayscale(1)',
                }}
                onClick={() => {
                  if (isCurrencySupported(type)) setMerchant(type);
                }}
              >
                {type === 'cash' ? (
                  <>
                    <img src={icon} alt="" style={{ width: '26px' }} />
                    <Typography.Text strong style={{ fontSize: '0.85rem', marginLeft: '4px' }}>
                      Cash
                    </Typography.Text>
                  </>
                ) : (
                  <img src={icon} alt="" style={{ width: '66px' }} />
                )}
              </Button>
            </Tooltip>
          ),
        )}
      </div>
    </Modal>
  );
};

/**
 * Renders the AddressFields component.
 *
 * @param {Object} props - The component props.
 * @param {Object} props.currentQuestion - The current question object.
 * @param {import('react-hook-form').UseFieldArrayReturn<FieldValues, "merchants", "id">} props.fieldArrayProps - The field array props.
 * @param {Function} props.update - The update function.
 * @returns {JSX.Element|JSX.Element[]} The AddressFields component.
 */
const AddressFields = ({ currentQuestion, fieldArrayProps, update }) => {
  const { t } = useTranslation(['builder']);

  const { fields, update: updateFieldArray } = fieldArrayProps;
  const { getValues } = useFormContext();

  const updateField = (index, field) => {
    // updateFieldArray(index, field);
    const updatedFields = getValues('fields');
    update({ fields: updatedFields });
  };

  // return (
  //   <div className="form-group" style={{ gap: 16 }}>
  //     {fields.map((field, index) => (
  //       <AddressFieldItem key={field.id} field={field} index={index} updateField={updateField} />
  //     ))}
  //   </div>
  // );
  return (
    <Collapse defaultActiveKey={[0]} accordion>
      {fields.map((field, index) => (
        <Collapse.Panel header={field.label} key={index}>
          <AddressFieldItem field={field} index={index} updateField={updateField} />
        </Collapse.Panel>
      ))}
    </Collapse>
  );
};

// const AddressFieldItem = ({ field, index, updateField }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const { control, getValues } = useFormContext();
//   const [key, setKey] = useState(0);
//   const { t } = useTranslation(['builder']);

//   return (
//     <div
//       style={{
//         borderRadius: 5,
//         border: '1px solid #d9d9d9',
//         overflow: 'hidden',
//       }}
//     >
//       <div
//         style={{
//           marginBottom: '8px',
//           display: 'flex',
//           justifyContent: 'space-between',
//           padding: '10px 16px',
//           paddingRight: '8px',
//           backgroundColor: '#f7f7f7',
//           borderBottom: 'inherit',
//           // borderRadius: 6,
//           // borderBottom: '1px solid rgba(0, 0, 0, 0.5)',
//         }}
//       >
//         <Typography.Text strong>{field.label}</Typography.Text>
//       </div>

//       <div
//         key={field.id}
//         style={{
//           display: 'flex',
//           flexDirection: 'column',
//           gap: 8,
//           padding: '10px 16px',
//         }}
//       >
//         {/* <label>{field.label}</label> */}
//         {/* <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
//         <Button type="text" shape="circle" onClick={() => setIsOpen(true)}>
//           <EditOutlined style={{ fontSize: '1.2rem', color: 'gray' }} />
//         </Button>
//         <Controller
//           render={({ field: { value, ...rest } }) => (
//             <Switch
//               checked={value}
//               {...rest}
//               onChange={(value) => {
//                 rest.onChange(value);
//                 updateField();
//               }}
//               size="small"
//             />
//           )}
//           name={`fields.${index}.enabled`}
//           control={control}
//         />
//       </div> */}
//         <div className="Properties-panel">
//           <div className="form-group">
//             <label className="form-group-label">
//               {t('builder:propertiesPanel.address.label', 'Label')}
//             </label>
//             <Controller
//               render={({ field, fieldState: { error, invalid } }) => (
//                 <Input
//                   size="large"
//                   status={invalid ? 'error' : ''}
//                   {...field}
//                   onChange={(e) => {
//                     field.onChange(e);
//                     if (!invalid) updateField(index, { ...field, label: e.target.value });
//                   }}
//                 />
//               )}
//               name={`fields.${index}.label`}
//               control={control}
//               rules={{ required: true }}
//             />
//             {/* {errors.label && (
//             <span className="ant-form-item-explain-error">This field is required</span>
//           )} */}
//           </div>

//           <div className="form-group row">
//             <label className="form-group-label">
//               {t('builder:propertiesPanel.required.label', 'Required')}
//             </label>
//             <Controller
//               render={({ field: { value, ...rest } }) => (
//                 <Switch
//                   checked={value}
//                   {...rest}
//                   onChange={(value) => {
//                     rest.onChange(value);
//                     updateField(index, { ...field, required: value });
//                   }}
//                 />
//               )}
//               name={`fields.${index}.required`}
//               control={control}
//             />
//           </div>
//           <div className="form-group row">
//             <label className="form-group-label">
//               {t('builder:propertiesPanel.enabled.label', 'Enabled')}
//             </label>
//             <Controller
//               render={({ field: { value, ...rest } }) => (
//                 <Switch
//                   checked={value}
//                   {...rest}
//                   onChange={(value) => {
//                     rest.onChange(value);
//                     updateField(index, { ...field, enabled: value });
//                   }}
//                 />
//               )}
//               name={`fields.${index}.enabled`}
//               control={control}
//             />
//           </div>
//           {/* <Divider /> */}
//         </div>
//         {/* <AddressFieldEditor
//         isOpen={isOpen}
//         field={field}
//         key={key}
//         setKey={setKey}
//         handleOk={(data) => {
//           updateField(index, { ...field, ...data });
//           setIsOpen(false);
//         }}
//         handleCancel={() => {
//           setIsOpen(false);
//         }}
//       /> */}
//       </div>
//     </div>
//   );
// };
const AddressFieldItem = ({ field, index, updateField }) => {
  const { control } = useFormContext();
  const { t } = useTranslation(['builder']);

  return (
    <div>
      <div
        key={field.id}
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 8,
        }}
      >
        <div className="Properties-panel">
          <div className="form-group">
            <label className="form-group-label">
              {t('builder:propertiesPanel.address.label', 'Label')}
            </label>
            <Controller
              render={({ field, fieldState: { error, invalid } }) => (
                <Input
                  size="large"
                  status={invalid ? 'error' : ''}
                  {...field}
                  onChange={(e) => {
                    field.onChange(e);
                    if (!invalid) updateField(index, { ...field, label: e.target.value });
                  }}
                  onBlur={(e) => {
                    console.log('onBlur', e);
                    // updateField(index, { ...field, label: field.value });
                  }}
                />
              )}
              name={`fields.${index}.label`}
              control={control}
              rules={{ required: true }}
            />
          </div>

          <div className="form-group row">
            <label className="form-group-label">
              {t('builder:propertiesPanel.required.label', 'Required')}
            </label>
            <Controller
              render={({ field: { value, ...rest } }) => (
                <Switch
                  checked={value}
                  {...rest}
                  onChange={(value) => {
                    rest.onChange(value);
                    updateField(index, { ...field, required: value });
                  }}
                />
              )}
              name={`fields.${index}.required`}
              control={control}
            />
          </div>
          <div className="form-group row">
            <label className="form-group-label">
              {t('builder:propertiesPanel.enabled.label', 'Enabled')}
            </label>
            <Controller
              render={({ field: { value, ...rest } }) => (
                <Switch
                  checked={value}
                  {...rest}
                  onChange={(value) => {
                    rest.onChange(value);
                    updateField(index, { ...field, enabled: value });
                  }}
                />
              )}
              name={`fields.${index}.enabled`}
              control={control}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const AddressFieldEditor = ({ isOpen, handleOk, handleCancel, field, setKey }) => {
  const { t } = useTranslation(['builder']);

  const {
    control,
    getValues,
    formState: { errors },
  } = useForm({
    values: field,
    mode: 'onChange',
  });

  const onOk = () => {
    if (Object.keys(errors).length > 0) return;
    const values = getValues();
    handleOk(values);
  };

  const onCancel = () => {
    handleCancel();
  };

  return (
    <Modal
      title={t('builder:propertiesPanel.address.editField', 'Edit Field')}
      visible={isOpen}
      onOk={onOk}
      okText={t('translation:common:save', 'Save')}
      onCancel={onCancel}
      centered
      afterClose={() => setKey((key) => key + 1)}
      destroyOnClose
    >
      <div className="Properties-panel">
        <div className="form-group">
          <label className="form-group-label">
            {t('builder:propertiesPanel.address.label', 'Field label')}
            {/* <Tooltip
              placement="top"
              title={t('builder:propertiesPanel.text.labelTooltip', 'Type your question')}
            >
              <QuestionCircleOutlined />
            </Tooltip> */}
          </label>
          <Controller
            render={({ field }) => (
              <Input size="large" status={errors.label ? 'error' : ''} {...field} />
            )}
            name="label"
            control={control}
            rules={{ required: true }}
          />
          {errors.label && (
            <span className="ant-form-item-explain-error">This field is required</span>
          )}
        </div>
        <Divider />
        <div className="form-group row">
          <label className="form-group-label">
            {t('builder:propertiesPanel.required.label', 'Required')}
          </label>
          <Controller
            render={({ field: { value, ...rest } }) => <Switch checked={value} {...rest} />}
            name="required"
            control={control}
          />
        </div>
      </div>
    </Modal>
  );
};

// const TagEditor = ({ tags, control, updateTag, addTags, removeTag }) => {
//   const [inputVisible, setInputVisible] = useState(false);
//   const [editIndex, setEditIndex] = useState(-1);
//   const editInputRef = useRef(null);
//   const { t } = useTranslation(['builder']);

//   useEffect(() => {
//     if (inputVisible || editIndex !== -1) {
//       editInputRef.current && editInputRef.current.focus();
//     }
//   }, [editIndex, inputVisible]);

//   const add = (e) => {
//     const { value } = e.target;
//     if (!value.trim()) return setInputVisible(false);
//     const options = value
//       .split(',')
//       .filter((v) => !!v.trim())
//       .map((v) => ({ _id: ObjectId(), label: v.trim(), value: '', media: '' }));
//     addTags(options);
//     setInputVisible(false);
//   };

//   const remove = (e, index) => {
//     e.preventDefault();
//     removeTag(index);
//     updateTag();
//   };

//   return (
//     <div className="tag-group">
//       {tags.map((tag, index) => (
//         <Controller
//           key={index}
//           render={({ field }) => {
//             const tagElm = (
//               <Tag closable onClose={(e) => remove(e, index)} onClick={() => setEditIndex(index)}>
//                 {tag.label.length > 20 ? `${tag.label.slice(0, 20)}...` : tag.label}
//               </Tag>
//             );
//             return editIndex === index ? (
//               <Input
//                 size="large"
//                 {...field}
//                 ref={editInputRef}
//                 onChange={(e) => {
//                   field.onChange(e);
//                   updateTag(e.target.value);
//                 }}
//                 onBlur={() => setEditIndex(-1)}
//                 onPressEnter={() => setEditIndex(-1)}
//                 style={{ width: '100%' }}
//               />
//             ) : tag.label.length > 20 ? (
//               <Tooltip title={tag.label} key={tag.label}>
//                 {tagElm}
//               </Tooltip>
//             ) : (
//               tagElm
//             );
//           }}
//           name={`options.${index}.label`}
//           control={control}
//           defaultValue={tag.label} // make sure to set up defaultValue
//         />
//       ))}
//       {inputVisible && (
//         <Input
//           ref={editInputRef}
//           type="text"
//           className="tag-input"
//           onBlur={add}
//           onPressEnter={add}
//           placeholder={t(
//             'builder:propertiesPanel.dropwdown.addInputPlaceholder',
//             'option 1, option 2, etc',
//           )}
//         />
//       )}
//       {!inputVisible && (
//         <Tag className="site-tag-plus" onClick={() => setInputVisible(true)}>
//           <PlusOutlined /> {t('builder:propertiesPanel.dropwdown.addOption', 'Add option')}
//         </Tag>
//       )}
//     </div>
//   );
// };

const MemoizedComponent = memo(FieldProperties, isEqual);

export default MemoizedComponent;
